export default __webpack_public_path__ + "static/media/home.46d0bbd4.png";